import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { styled } from '@mui/material/styles'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import Table from '@views/monitoring/table/Table'

import {
  createReport,
} from '@store/report'

const StyledDialogContent = styled(DialogContent)({
  backgroundColor: '#fdfdfd',
  borderTop: '1px solid #eee',
  borderBottom: '1px solid #eee',
  padding: 30
})
const FloatButtons = styled('div')({
  float: 'right',
  marginRight: 5
})
const FloatButton = styled(Button)({
  width: 105,
  marginLeft: 10
})

const MonitoringModal = ({
  open,
  closeMonitoring
}) => {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('lg'))
  const [ selecteds, setSelecteds ] = useState({})
  const [ etcs, setEtcs ] = useState({})
  const dispatch = useDispatch()
  const {
    companyList,
  } = useSelector(store => store.report)

  const handleClose = (e, reason) => {
    if (reason === 'backdropClick') {
      return
    }

    const reportForm = {
      reportList: companyList.map((company => {
        const isMember = selecteds[company.companyId][0]
        const isCompany = selecteds[company.companyId][1]
        const isEtc = isMember || isCompany
        return {
          companyId: company.companyId,
          companyIdentify: company.companyIdentify,
          member: selecteds[company.companyId][0],
          company: selecteds[company.companyId][1],
          etc: isEtc ? etcs[company.companyId] : '',
        }
      }))
    }

    dispatch(createReport(reportForm))
    closeMonitoring()
  }

  const toggleSelect = ({
    key,
    index,
    selected
  }) => {
    const updatedSelecteds = Object.assign({}, selecteds)
    updatedSelecteds[key][index] = selected
    setSelecteds(updatedSelecteds)
  }

  const changeEtc = ({
    key,
    value
  }) => {
    const updatedEtcs = Object.assign({}, etcs)
    updatedEtcs[key] = value
    setEtcs(updatedEtcs)
  }

  const allSelect = useCallback((result) => {
    let tempSelecteds = {}
    companyList.forEach(data => {
      tempSelecteds[data.companyId] = [result, result]
    })
    setSelecteds(tempSelecteds)
  }, [ companyList ])

  const allGroupSelect = (groupId, result) => {
    let tempSelecteds = Object.assign({}, selecteds)
    tempSelecteds[groupId] = [result, result]
    setSelecteds(tempSelecteds)
  }

  useEffect(() => {
    allSelect(false)
  }, [ allSelect ])

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown
      aria-labelledby="관리자 등록/변경"
      fullWidth={true}
      maxWidth={'lg'}
    >
      <DialogTitle id="responsive-dialog-title">
        매주 첫번째 영업일에 등록 해주세요
        <FloatButtons>
          <FloatButton variant="outlined" color="primary" onClick={() => allSelect(true)}>Y 전체</FloatButton>
          <FloatButton variant="outlined" color="primary" onClick={() => allSelect(false)}>N 전체</FloatButton>
        </FloatButtons>
      </DialogTitle>
      <StyledDialogContent>
        {
          companyList.map(data => {
            return (
              <Table
                key={data.companyId}
                data={data}
                selecteds={selecteds}
                etcs={etcs}
                toggleSelect={toggleSelect}
                changeEtc={changeEtc}
                allGroupSelect={allGroupSelect}
              />
            )
          })
        }
      </StyledDialogContent>
      <DialogActions>
        <Button variant="contained" disableElevation onClick={handleClose}>
          등록
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MonitoringModal